import { getCookie, setCookie } from 'cookies-next'
import { useCallback, useState } from 'react'

export function useCookie<T>(
  key: string,
  initialValue: T,
  session: boolean = false
): [T, (value: T, options?: { maxAge?: number | undefined }) => void] {
  const [storedValue, setStoredValue] = useState<T>(() => {
    const item = getCookie(key)
    return item ? JSON.parse(String(item)) : initialValue
  })

  const setValue = useCallback(
    (value: T, options: { maxAge?: number | undefined } = {}) => {
      setStoredValue(value)
      const maxAgeValue =
        options?.maxAge || (session ? 60 * 60 * 1 : 60 * 60 * 24 * 365) // 1 hour or 1 year
      setCookie(key, JSON.stringify(value), { maxAge: maxAgeValue })
    },
    [key, session]
  )

  return [storedValue, setValue]
}

export default useCookie
